export default {
  validations: {
    REQUIRED_IVALID: "Campos com '*' são obrigatórios.",
    SUGGESTION_INVALID_VALUE: 'Selecione um valor válido da caixa de sugestões.',
    HORA_INVALID: 'As horas devem estar entre {0} e {1}.',
    EMAIL_INVALID: 'Insira um email válido.',
    STRING_SPACE_INVALID: 'Não é permitido espaços em branco.',
    MIN_LENGTH_INVALID: (value) => `O valor mínimo aceito são ${value} caracteres.`,
    MAX_LENGTH_INVALID: (value) => `O valor máximo aceito são ${value} caracteres.`,
    MIN_INVALID: (value) => `O valor deve ser maior ou igual a ${value}.`,
    MAX_INVALID: (value) => `O valor deve ser menor ou igual a ${value}.`,
    CPF_INVALID: 'CPF inválido.',
    CNPJ_INVALID: 'CNPJ inválido.',
    EXTENSION_FILE_INVALID: 'Formato de arquivo inválido.',
    TELEFONE_INVALID: 'Telefone inválido.',
    MAX_LENGTH_NAME_FILE: (value) => `O Nome do Arquivo aceita no máximo ${value} caracteres.`,
    MAX_LENGTH_FILE: (value) => `O tamanho do arquivo não pode ser maior que ${value}MB.`,
    MAX_VALOR: (value) => `O valor máximo aceito é ${value}.`,
    MIN_VALOR: (value) => `O valor mínimo aceito é ${value}.`,
  },
};
